export default __webpack_public_path__ + "static/media/hot-dog-cart-open.d43076f2.png";